<template>
  <div class="c-controls">
    <div class="c-controls__group">
      <label class="c-controls__label">What if</label>
      <button class="button button--control" v-on:click.prevent="spin">Creëer een vraag</button>
    </div>
  </div>
</template>

<script>
import BaseControl from './BaseControl';

export default {
	name: 'WhatIfControl',
	mixins: [BaseControl],
	methods: {
		spin() {
			this.subcommand('whatif.spin');
		},
	},
};
</script>

<style scoped></style>
